import { orderStatus } from '@/constants';
import { orderPushService } from '@/lib/list-control/orderPushService';
/**
 * 주문 푸시 이벤트 메서드 맵퍼
 * FLOW
 * vue component (push handler) >> push methods >> push service >> vuex
 */
export const orderPushMethods = {
    /**
     * 대기 -> 제거
     */
    [orderStatus.WAITED.code](orderData) {
        orderPushService.deleteOrder(orderData);
    },
    /**
     * 대기 취소 -> 접수
     */
    [orderStatus.WAIT_END.code](orderData) {
        orderPushService.mergeStatusAccepted(orderData);
    },
    /**
     * 자체 배달 -> 제거
     * 상점에서 자체 배달하기에 지도관제에서 노출될 필요 x
     */
    [orderStatus.SELF_DELIVERY.code](orderData) {
        orderPushService.deleteOrder(orderData);
    },
    /**
     * 예약 -> 제거
     */
    [orderStatus.RESERVED.code](orderData) {
        orderPushService.deleteOrder(orderData);
    },
    /**
     * 예약 취소 -> 접수
     */
    [orderStatus.RESERVE_END.code](orderData) {
        orderPushService.mergeStatusAccepted(orderData);
    },
    /*
    * 접수
    */
    [orderStatus.ACCEPTED.code](orderData) {
        orderPushService.mergeOrder(orderData);
    },
    /**
     * 재접수 -> 접수
     */
    [orderStatus.RE_ACCEPT.code](orderData) {
        orderPushService.mergeStatusAccepted(orderData);
    },
    /**
     * 배차 요청 -> 업데이트
     */
    [orderStatus.WORKER_REQUESTED.code](orderData) {
        orderPushService.mergeOrder(orderData);
    },
    /**
     * 배차
     */
    [orderStatus.ALLOCATED.code](orderData) {
        orderPushService.mergeStatusAllocated(orderData);
    },
    /**
     * 즉시 배차 -> 배차
     */
    [orderStatus.IMMEDIATE_ALLOCATE.code](orderData) {
        orderPushService.mergeStatusAllocated(orderData);
    },
    /**
     * 픽업 도착
     */
    [orderStatus.PICKUP_ARRIVED.code]() {
    },
    /**
     * 픽업 완료 -> 픽업
     */
    [orderStatus.PICKUP_FINISHED.code](orderData) {
        orderPushService.pickUp(orderData);
    },
    /**
     * 배달 완료 -> 제거
     */
    [orderStatus.DROP_FINISHED.code](orderData) {
        orderPushService.mergeOrder(orderData);
    },
    /**
     * 주문 취소 -> 업데이트
     */
    [orderStatus.CANCELED.code](orderData) {
        orderPushService.mergeOrder(orderData);
    },
    /**
     * 주문 정보 변경 -> 업데이트
     * @param
     */
    [orderStatus.ORDER_MODIFY.code](pushData) {
        orderPushService.orderModify(pushData);
    },
    /**
     * 배차요청취소 -> 접수
     */
    [orderStatus.WORKER_REQUESTED_CANCEL.code](orderData) {
        orderPushService.workerRequestedCancel(orderData);
    },
    /**
     * 배차 취소 -> 접수
     */
    [orderStatus.ALLOCATE_CANCEL.code](pushData, _isShareOrder = false) {
        orderPushService.allocateCancel(pushData, _isShareOrder);
    },
};
